import WarningDialog from '@sophocles/components/WarningDialog/WarningDialog';

export default WarningDialog;
